import {roamingInvoiceFormExecutorOrCustomer} from "./hoc/roamingInvoiceFormExecutorOrCustomer";

const RoamingConstructionInvoiceCustomerForm = roamingInvoiceFormExecutorOrCustomer('RoamingConstructionInvoiceCustomerForm')
export default RoamingConstructionInvoiceCustomerForm
